// extracted by mini-css-extract-plugin
export var container = "_6y-0";
export var fallback = "_6y-5";
export var fallbackIcon = "_6y-6";
export var hidden = "_6y-2";
export var image = "_6y-3";
export var loaded = "_6y-4";
export var placeholder = "_6y-1";